import React, { FC, useState, useEffect, memo } from "../../../lib/teact/teact";
import LotSelect from "../ui/lotSelect";
import './ThamSoTheoLoaiCuoc.scss'
type OwnProps = {
    dai: string;
    group: string;// 2C,3C,4C,Da
    parentState: any,
    canChuyenParam: any,
    onUpdateParam: (param: any) => void;
}

const ThamSoTheoDai: FC<OwnProps> = ({
    parentState,
    dai,
    group,
    canChuyenParam,
    onUpdateParam,
}) => {
    const [state, setState] = useState({
        KieuGiuDau: "DIEM",
        KieuGiuDuoi: "DIEM",
        KieuGiuLo: "DIEM",
        KieuGiuDa: "DIEM",
        DiemGiuDau: 0,
        DiemGiuDuoi: 0,
        DiemGiuLo: 0,
    })
    const cc = canChuyenParam;
    function handleParamChange(subGroup: string, value: number | string, field: string) {
        const payload = { dai: dai, group: group, subGroup: subGroup, value: value, field: field }
        if (typeof value == 'number' && isNaN(value))
            payload.value = 0
        onUpdateParam(payload)
        console.log(payload)
    }
    if (!cc)
        return <></>
    if (!cc[dai])
        return <></>
    if (!cc[dai]["DAU"])
        return <></>
    return (
        <div className=" ts-container">
            <div className="lot-title">{dai}</div>
            <div className="tsd-grid">
                <div>Đầu</div>
                <LotSelect value={cc[dai]["DAU"].kieuGiu}
                    onChange={(e) => { handleParamChange("DAU", e.target.value, "kieuGiu") }}
                    id="l-kieu-giu-dau">
                    <option value={"DIEM"} selected={cc[dai]["DAU"].kieuGiu == "DIEM"}>Giữ theo điểm</option>
                    <option value={"PT"} selected={cc[dai]["DAU"].kieuGiu == "PT"}>Giữ theo %</option>
                </LotSelect>
                <input value={cc[dai]["DAU"].diemGiu} className="lot-input"
                    onChange={(e) => { handleParamChange("DAU", Number(e.target.value), "diemGiu") }}></input>
            </div>
            <div className="tsd-grid">
                <div>Đuôi</div>
                <LotSelect value={cc[dai]["DUOI"].kieuGiu}
                    onChange={(e) => { handleParamChange("DUOI", e.target.value, "kieuGiu") }}
                    id="l-kieu-giu-duoi">
                    <option value={"DIEM"} selected={cc[dai]["DUOI"].kieuGiu == "DIEM"}>Giữ theo điểm</option>
                    <option value={"PT"} selected={cc[dai]["DUOI"].kieuGiu == "PT"}>Giữ theo %</option>
                </LotSelect>
                <input value={cc[dai]["DUOI"].diemGiu} className="lot-input"
                    onChange={(e) => { handleParamChange("DUOI", Number(e.target.value), "diemGiu") }}></input>
            </div>
            <div className="tsd-grid">
                <div>Lô</div>
                <LotSelect value={cc[dai]["LO"].kieuGiu}
                    onChange={(e) => { handleParamChange("LO", e.target.value, "kieuGiu") }}
                    id="l-kieu-giu-lo">
                    <option value={"DIEM"} selected={cc[dai]["LO"].kieuGiu == "DIEM"}>Giữ theo điểm</option>
                    <option value={"PT"} selected={cc[dai]["LO"].kieuGiu == "PT"}>Giữ theo %</option>
                </LotSelect>
                <input value={cc[dai]["LO"].diemGiu} className="lot-input"
                    onChange={(e) => { handleParamChange("LO", Number(e.target.value), "diemGiu") }}></input>
            </div>
        </div>
    )
}
export default memo(ThamSoTheoDai)